import React from 'react';

export const MostPopularBadge = () => {
  return <div className="most-popular margin-bottom-10">MOST POPULAR</div>;
};
